import { SensorType } from "common";
import { useTranslation } from "react-i18next";

export const useSensorType = () => {
  const { t } = useTranslation();

  const translateSensorType = (type: SensorType | undefined): string => {
    switch (type) {
      case SensorType.AIR_QUALITY:
        return t("sensors.type.airQuality");
      case SensorType.CO2:
        return t("sensors.type.co2");
      case SensorType.ELECTRICAL:
        return t("sensors.type.electrical");
      case SensorType.HUMIDITY:
        return t("sensors.type.humidity");
      // SensorType.HVAC is an alias for HVAC_AIRHANDLER_MONITOR — both halves of
      // a pair are deployed in the fleet, so name them apart rather than showing
      // the condenser as "Unknown".
      case SensorType.HVAC_AIRHANDLER_MONITOR:
        return t("sensors.type.hvacAirHandler");
      case SensorType.HVAC_CONDENSER_MONITOR:
        return t("sensors.type.hvacCondenser");
      case SensorType.LEAK_DETECTOR:
        return t("sensors.type.leakDetector");
      case SensorType.LIGHT:
        return t("sensors.type.light");
      case SensorType.PM10:
        return t("sensors.type.pm10");
      case SensorType.PM25:
        return t("sensors.type.pm25");
      case SensorType.POWER:
      case SensorType.POWER_ALT:
        return t("sensors.type.power");
      case SensorType.PRESSURE:
        return t("sensors.type.pressure");
      case SensorType.TEMPERATURE:
        return t("sensors.type.temperature");
      case SensorType.VOC:
        return t("sensors.type.voc");
      case SensorType.WATER_QUALITY:
        return t("sensors.type.waterQuality");
      default:
        return t("sensors.type.unknown");
    }
  };

  return {
    translateSensorType,
  };
};
